export default {
  // Browser tab title (decided by domain on production, see src/i18n/domains.js; updates on switch in local dev)
  pageTitle: 'Shenzhen Cofoe CGM System',
  // Share card title (og:title; static HTML output by build:en, see public/index.html)
  pageShareTitle: 'Shenzhen Cofoe CGM System',
  // Page description (meta description / og:description; static HTML output by build:en, see public/index.html)
  pageDescription: 'Know Your Rhythm. Embrace a Healthier Life.',
  // Navigation
  nav: {
    home: 'Home',
    product: 'Product',
    service: 'Service & Support',
    download: 'Download',
    about: 'About Us'
  },
  // Language
  lang: {
    zh: '简体中文',
    en: 'English'
  },
  // Home Page
  home: {
    smallword1: 'Real-Time Protection',
    smallword2: 'Remote Care',
    smallword3: 'Finger-Prick Free',
    heroTitle: 'Cofoe®',
    heroSubtitle: 'CGM System',
    heroBtn: 'Learn More',
    serviceTitle: 'Service & Support',
    serviceDesc: 'Cofoe With a professional medical service ecosystem, we offer in-hospital and out-of-hospital blood sugar management solutions to help users improve their blood sugar control, and assist medical institutions in building a digital all-hospital blood sugar management system.',
    serviceBtn: 'Contact Us',
    missionTitle: 'Our Mission',
    missionDesc: 'Accelerate the development of private \nhealthcare through technology \nMake health a right that belongs to everyone.',
    shareTitle: 'Caring for Your Health Is Our Unwavering Commitment',
    shareSubtitle: 'Respect user experience and \npursue ultimate quality',
    shareDesc: 'Cofoe always prioritizes user experience. Our products not only incorporate the latest technologies, but are also developed based on users\' pain points and for users. Cofoe\'s exploration of changing chronic disease management has never stopped. It is committed to redefining the product experience for chronic diseases and creating products that are recognized by users and offer good value for money.',
    modeTitle: 'Business Across Global Markets',
    modeDesc: 'We specialize in medical devices with global reach. Equipped with full international certifications, cross-border logistics and localized after-sales service networks, we advance global healthcare development and jointly foster an affordable, inclusive healthcare ecosystem.',
    extraTitle: 'Strict Quality Control Throughout The Entire Process',
    extraCardTitle: 'Excellent Team',
    extraCardDesc: 'Our team comprises hardware, software and algorithm specialists. End-to-end quality control ensures zero defects. With fully in-house original R&D, our globally-sold devices deliver sustained premium quality guarantees.'
  },
  // Product Page
  product: {
    title: 'Cofoe Futan',
    subtitle: 'Continuous Glucose Monitoring System',
    hourText: 'Hour',
    dayText: 'Day',
    feature1: '24/7 monitoring, your 14-day glucose companion',
    feature2: 'Daily trends at a glance',
    feature3: 'Monitor glucose data on mobile app in real-time',
    painlessTitle: 'Painless Wearing\nMore Comfortable',
    painlessDesc: 'Integrated Design|\nSimple Operation|\nFlexible Soft Needle|\nComfortable To Wear',
    bluetoothTitle: 'Bluetooth 5.0 Transmission',
    bluetoothSubtitle: '24h Stable Monitoring\nReal-Time\nGlucose Data',
    calibTitle: 'No Calibration Required.\nMore Convenient.',
    calibDesc: 'No Need To Prick The Finger For \nCalibration Reduce The Number\nOf Blood Draws',
    compactDesc: 'Weighs≈3g|\nIP28 Waterproof And Dustproof',
    reportTitle: 'Intuitive Data Viewing',
    reportDesc: 'Professional Graph Reports|\nEasy Glycemic Control',
    compactTitle: 'Compact Size\n' +
        'Easy To Wear And Carry',
    compactSubtitle: 'Low-profile design for comfortable wear',
    sceneTitle: 'Multi-Scenario Adaptability Built For Challenges',
    sceneSubtitle: 'Glycemic Control ≠ Restricted Freedom',
    sceneSport: 'Sports',
    sceneShower: 'Shower',
    sceneSwim: 'Swimming',
    sceneWork: 'Work',
    sceneDaily: 'Daily Life',
    sceneSleep: 'Sleep',
    heroTitle: 'Cofoe®',
    heroSubtitle: 'Continuous Glucose Monitoring System',
    heroDesc: '14‑day continuous dynamic glucose monitoring. No frequent finger pricks, no manual scanning. View real‑time glucose curves on mobile App. Cofoe eases daily glucose management with technology. Get actionable reference for diet and exercise, helping you safeguard your health steadily.',
    recordTitle: 'Easily Log and Check-in for Glucose Control',
    recordSubtitle: 'Manage Glucose In Diet & Exercise with Smart Planning',
    agpTitle: 'AGP Report For Precise Diabetes Management',
    agpSubtitle: 'Precision And Scientific Health Management Of Diabetes',
    agpPoint1: 'CGM Guidelines Unanimously Recommend Continuous Glucose Monitoring System For Inpatients To Monitor And Control Blood Glucose',
    agpPoint2: 'Records And Analyzes Patient Glucose Data To Generate AGP Reports, Giving Doctors A Comprehensive Real-Time View Of Glucose Levels',
    agpPoint3: 'Shared Glucose Management Data Helps Doctors Track Condition Changes Anytime And Adjust Treatment Plans',
    analysisTitle: 'Glucose Analysis & Periodic Review',
    analysisSubtitle: 'Automatic Periodic Glucose Report After Wearing',
    expertTitle: 'Expert-Level Blood Glucose Report',
    expertPoint1: 'Real-time monitoring data with detailed statistics, glucose indicators at a glance.',
    expertPoint2: 'Standardized glucose report generation with comprehensive assessment, supporting your glucose management journey.',
    cardAvgLabel: 'Average Glucose Level',
    cardAvgUnit: 'MG',
    cardAvgValue: '6.4',
    cardAvgUnit2: 'mmol/L',
    cardAvgTarget: 'Target <6.6',
    cardHbLabel: 'Estimated HbA1c',
    cardHbUnit: 'eHbA1c',
    cardHbValue: '5.8',
    cardHbPercent: '%',
    cardHbTarget: 'Target <7%',
    modelTitle: 'Three Modes Switch Freely',
    modelSubtitle: 'Suitable For Different User Groups. Easy To Use Without Any Difficulty',
    modePro: 'Professional Mode',
    modeProDesc: 'Professional Mode is designed for regular users, providing complete core functions including real-time glucose monitoring, AGP standardized reports, event recording, periodic review, and data statistical analysis. It clearly displays glucose fluctuation curves and various indicators, helping you fully understand your glucose changes and scientifically manage daily glucose control.',
    modeFamily: 'Family Mode',
    modeFamilyDesc: 'Family Mode supports binding multiple family members\' devices, allowing remote viewing of their real-time glucose values, periodic reports, and glucose fluctuation status. Without face-to-face contact, you can promptly grasp family glucose dynamics and notice abnormalities at the first moment, remotely guarding your family\'s glucose health.',
    modeCare: 'Care Mode',
    modeCareDesc: 'Care Mode is optimized for elderly users, with enlarged interface fonts, icons, and controls. It simplifies complex page information and prominently displays key glucose data. It lowers the reading and operation threshold, making it easy for seniors to read glucose results and complete basic glucose management with simple operation.',
    officialShop: 'Cofoe Official Store',
    shopTmall: 'Cofoe Tmall Store',
    shopJd: 'Cofoe JD Store',
    shopPdd: 'Cofoe PDD Store'
  },
  // Service Page
  service: {
    title: 'Service & Support',
    faqTitle: 'Frequently Questions',
    tutorialTitle: 'Product Usage Tutorial',
    video1Label: 'Product Wearing Demo',
    video2Label: 'APP Connection Demo',
    scanQR: 'Scan QR Code',
    followUs: ' Follow Cofoe ',
    afterSales: ' After-sales Support',
    heroEmail: 'aftersales@szcofoe.com',
    heroEmailLabel: 'After-sales Email',
    heroPhone: '+86 755 2331 6007',
    heroPhoneLabel: 'After-sales Service',
    pdfEntry: 'Product User Manual (PDF)',
    videoNotSupport: 'Your browser does not support video playback',
    // FAQ questions & answers (faqQ = question, faqA = answer, \n rendered by CSS)
    faqQ1: 'What is CGMS?',
    faqA1: 'The Continuous Glucose Monitoring System (CGMS) is a portable medical device that continuously monitors glucose concentration in interstitial fluid in real time to reflect blood glucose levels. It is mainly used for glucose management in diabetic patients. Compared with traditional fingertip blood sampling (instant glucose testing), it provides more comprehensive and dynamic information on glucose fluctuations.',
    faqQ2: 'How long is the wear time of the Cofoe CGM?',
    faqA2: 'A single wear of the Cofoe CGM continuously monitors glucose values for 14 days, uploading a glucose reading every 5 minutes, which helps analyze dynamic trends in glucose changes.',
    faqQ3: 'How to choose the correct wear site?',
    faqA3: 'Research feedback suggests that wearing the sensor on the back of the upper arm helps achieve the optimal wearing experience. We do not recommend wearing the Cofoe transmitter on the abdomen, thigh, buttocks, back, or muscle areas frequently used in daily activities and exercise, as this may cause the sensor to fall off unexpectedly. Please keep the wear site clean and avoid using body lotions or creams, as they may interfere with sensor readings and affect adhesive attachment. The ideal wear area should be free of birthmarks, stretch marks, or other lumps, with a smooth and flat surface. The ideal application site is the back of the upper arm.',
    faqQ4: 'Who is the Cofoe CGM suitable for?',
    faqA4: 'The Cofoe CGM is suitable for:\n1. Diabetic patients: including Type 1 (requiring insulin adjustment, etc.), Type 2 (using insulin / poorly controlled), and gestational diabetes patients;\n2. People with undiagnosed glucose abnormalities: those with prediabetes or at risk of hypoglycemia;\n3. Other scenarios: self-management for healthy people (e.g., diet adjustment), special medical scenarios (e.g., before and after surgery).',
    faqQ5: 'Can I apply it by myself?',
    faqA5: 'Yes, you can apply the Cofoe CGM by yourself. With a simple process that requires no assistance from professional medical staff. Please carefully read the user manual and quick start guide before wearing the device, and simply follow the instructions in the quick start guide.',
    faqQ6: 'Does wearing it hurt?',
    faqA6: 'Our sensor uses a minimally invasive soft-needle probe. Most users feel no pain at all during application, while a few may experience mild discomfort that decreases over time. If pain persists more than 12 hours after application, please contact Cofoe Futan customer service immediately.',
    faqQ7: 'Do I need to remove it when bathing?',
    faqA7: 'No, the product has IP28-level water resistance. The Cofoe transmitter can handle daily bathing and swimming scenarios.',
    faqQ8: 'How to handle Cofoe CGM disconnection?',
    faqA8: 'Key steps for handling Cofoe CGM disconnection:\n1. Reconnect or wake the device through the App;\n2. Check the device fit, restart Bluetooth and re-pair;\n3. Ensure you are within effective range and away from interference sources;\n4. Check battery level and update the software version;\n5. Restart your phone or switch to a different phone and re-pair;\n6. If the connection still fails after trying the above methods, please contact customer service to replace the sensor.'
  },
  // Download Page
  download: {
    title: 'Cofoe CGM APP',
    subtitle: 'Continuous Glucose Monitoring System App',
    desc: 'Not only does it provide monitoring and feedback, but the Cofoe CGM APP also offers a one-stop data statistics and standardized blood sugar report that you can view for free. The aim is to bring the new experience of smart personal care to your side',
    scanTip: 'Scan to Download\n"Cofoe CGM" APP',
    videoIOS: 'APP (iOS) Download Tutorial',
    videoAndroid: 'APP Download Tutorial',
    videoHarmony: 'APP (HarmonyOS) Download Tutorial',
    videoNotSupport: 'Your browser does not support video playback',
    // Module 4 texts
    mod4Title: 'Product Installation Tutorial',
    mod4Subtitle: 'The APP is now available on major app stores.\nUsers can scan the QR code to download directly.',
    // Module 2 texts
    mod2Title: 'More Than Monitoring, Your Glycemic Analysis Master',
    mod2Subtitle: 'Beyond routine glycemic monitoring, the Cofoe CGM App provides customized analysis and report feedback based on your usage patterns, making glycemic management closer to your life.',
    feature1: 'View Glycemic Compliance More Conveniently And Quickly; Glucose Status At A Glance',
    feature2: 'Real-Time Glucose Updates Every 5 Mins; View Readings And Remaining Time Of Wearing Anytime',
    feature3: 'Free Standardized Glucose Reports With Basic Stats & Advanced Data Insights',
    feature4: 'Multi-Day Glucose Curves For Trend Review & Comparison, Your Portable Glycemic Control Assistant',
    // Module 3 texts
    mod3Title: 'Multi-dimensional Analysis, Better Management',
    mod3Subtitle: 'Through daily analysis, periodic review, and event logging, we analyze from multiple perspectives of the wearing cycle and daily life, making blood sugar management easier and more accurate.',
    mod3CardTitle1: 'Daily Analysis',
    mod3CardSubtitle1: 'Day and night glucose fluctuations, all at a glance.',
    mod3CardTitle2: 'Period Review',
    mod3CardSubtitle2: 'Comprehensive 14-day glucose index analysis \nOne-click professional glucose report',
    mod3CardTitle3: 'Event Log',
    mod3CardSubtitle3: 'Record meals, medication, insulin injections and more\nSee glucose fluctuations before and after',
    mod3CardTitle4: 'Personal Center',
    mod3CardSubtitle4: 'Easily manage devices, share with family'
  },
  // About Page
  about: {
    title: 'About Us',
    heroTitle: 'Quality Without Limits\nService Without Boundaries',
    heroSubtitle: 'Customer satisfaction is our key to success',
    heroBtn: 'Join Us',
    introTitle: 'About Us',
    introSubtitle: 'Cofoe',
    companyName: 'Shenzhen Cofoe Biotechnology Co., Ltd.',
    companyDesc: 'Shenzhen Cofoe Biotechnology Co., Ltd. is located in Bao\'an District, Shenzhen, covering an area of approximately 3,000 square meters. It is a high-tech enterprise integrating R&D innovation, manufacturing, sales, and after-sales service. The company focuses on the core technology R&D and large-scale production of Continuous Glucose Monitoring Systems (CGMS), deeply engaged in precision medicine and health monitoring. Committed to becoming a global leader in continuous glucose monitoring.',
    iconLabel1: 'R&D',
    iconLabel2: 'Design',
    iconLabel3: 'Production',
    devTitle: 'Development History',
    devYear1: '2026',
    devDesc1: 'The self-developed continuous glucose monitoring system was approved by the NMPA and obtained the Class III medical device registration certificate. Subsequently obtained the production license and advertising review approval number for the CGM product, along with multiple design patents and supporting software copyrights.',
    devYear2: '2025',
    devDesc2: 'Accumulated approximately 70 patents and 12 software copyrights, with core technologies focused on biosensing and glucose monitoring sensors.',
    devYear3: '2024',
    devDesc3: 'The company was recognized as a provincial-level innovative SME, and began to obtain various patent authorizations in bulk during the same period.',
    devYear4: '2021',
    devDesc4: 'Invested and established by Cofoe Medical Technology Co., Ltd. as a wholly-owned subsidiary',
    contactTitle: 'Contact Us',
    afterSalesTitle: 'After-sales Service',
    afterSalesEmail: 'Email: ',
    afterSalesEmailValue: 'aftersales@szcofoe.com',
    afterSalesPhone: 'Tel: ',
    afterSalesPhoneValue: '+86 755 2331 6007',
    businessTitle: 'Business Contact',
    businessEmail: 'Email: ',
    businessEmailValue: 'CGM.sales@szcofoe.com',
    businessPhone: 'Tel: ',
    businessPhoneValue: '+86 755 2331 6007',
    qrLabel1: 'Scan\nFollow Cofoe Futan',
    qrLabel2: 'Scan\nAfter-sales Support',
    addressTitle: 'Company Address',
    addressDesc: 'B201,Building B and 301, 302, Building C, Sino-German (Europe) Industrial Park, Hangcheng Blvd, Bao\'an District, Shenzhen, 518100 Guangdong, P.R. China'
  },
  // Footer
  footer: {
    company: 'Cofoe',
    home: 'Home',
    homeSub: 'Cofoe',
    product: 'Product',
    productSub1: 'CGM System',
    productSub2: 'Online Store',
    service: 'Service',
    serviceSub1: 'Customer Service',
    serviceSub2: 'User Tutorial',
    serviceSub3: 'Frequently Asked Questions',
    download: 'Download App',
    downloadSub1: 'Android System',
    downloadSub2: 'iOS System',
    downloadSub3: 'Harmony OS System',
    about: 'About Us',
    aboutSub1: 'Company Profile',
    aboutSub2: 'Contact Us',
    copyright: 'copyright@2025 Shenzhen Cofoe Biotechnology Co., Ltd.',
    icp: 'Guangdong ICP No. 202536139-1',
    privacy: 'Privacy Policy & Terms',
    // 隐私政策链接：英文站指向国际接口
    privacyUrl: 'https://int.szcofoe.com/app/article/privacy-policy/info?language=en-US'
  }
}